import { i18next, resolveTranslationLanguage } from "@mivo/i18n";
import type { AnchorHTMLAttributes } from "react";
import { resolveMarketingUrl } from "../../crossHost/resolveMarketingUrl";

type MarketingSiteLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  path?: string;
  href?: string;
};

/** Cross-host link to the marketing site. Propagates active locale and market country on cross-host navigation. */
export function MarketingSiteLink({ path = "/", href, children, ...rest }: MarketingSiteLinkProps) {
  const locale = resolveTranslationLanguage(i18next.language);
  const resolvedHref = href ?? resolveMarketingUrl(path, locale);

  return (
    <a href={resolvedHref} {...rest}>
      {children}
    </a>
  );
}
